import { useEffect } from "react";
import ReactGA from "react-ga4";
import Home from "./pages/Home";
import Support from "./pages/Support";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

function App() {
	useEffect(() => {
		ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
		ReactGA.send({ hitType: "pageview", page: window.location.pathname });
	}, []);

	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/support" element={<Support />} />
				<Route
					path="*"
					element={
						<main>
							<h2 className="non-existing">404 Not Found</h2>
							<p>The page you are looking for does not exist.</p>
						</main>
					}
				/>
			</Routes>
		</Router>
	);
}

export default App;
